const login = () =>
    import ('@/views/login/index.vue');
const test = () =>
    import ('@/views/test/index.vue');

export default [
    {
        path: "/login",
        name: "login",
        components: {
            default: login,
        },
        meta: {
            nav: "login",
            keepAlive: false,
            hiddenNavigation:true
        },
    },
    {
        path: "/test",
        name: "test",
        components: {
            default: test,
        },
        meta: {
            nav: "test",
            keepAlive: true,
            hiddenNavigation:true
        },
    }
]


// WEBPACK FOOTER //
// ./src/vue/router/router.js